import { FileLoader } from "three";
import { LidarZoneSelectionModel } from "../types/laserScanScene";
import { useEffect, useCallback, useState } from "react";
import { useLaserScanScene } from "../providers/LaserScanSceneProvider";
import { useLaserSceneWorker } from "./useLaserSceneWorker";
import { CurrentProcessedThermalImageDataModel } from "../../irScanAnalysis/hooks/useGetProcessedThermalImages";

export const usePrepareProcessedLidarZoneSectionData = (
  filePath?: string,
  heatId?: string,
  lidarZoneSectionData?: LidarZoneSelectionModel[],
  processedThermalImages?: CurrentProcessedThermalImageDataModel,
) => {
  const { handleHeatDataUpdate } = useLaserScanScene();
  const { calculatePointCloud } = useLaserSceneWorker();

  const [loadingState, setLoadingState] = useState(0);

  const fetchData = useCallback(async () => {
    if (!filePath || !heatId || !lidarZoneSectionData) return;

    try {
      const heatsArray = [
        {
          id: heatId,
          dataUrl: filePath,
          columnCount: 8,
          dataFormat: "csv",
          description: "",
          title: "",
        },
      ];

      const csvLoader = new FileLoader();
      const data = await csvLoader.loadAsync(filePath, (progress) => {
        setLoadingState((progress.loaded / progress.total) * 100);
      });

      const processedData = await calculatePointCloud(
        data,
        heatsArray[0],
        lidarZoneSectionData,
      );

      handleHeatDataUpdate({
        ...processedData,
        shellData: processedThermalImages,
      });
    } catch (error) {
      throw new Error("Veri işleme hatası");
    }
  }, [
    filePath,
    heatId,
    lidarZoneSectionData,
    processedThermalImages,
    calculatePointCloud,
    handleHeatDataUpdate,
  ]);

  useEffect(() => {
    fetchData();
    return () => {};
  }, [fetchData]);

  return { loadingState };
};
